/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IState } from '../../store/types/StateTypes';

export default (state: IState) => {

    if (state.titleOptions.showTitleFlagFromAPI === false) {
        return false;
    }
    if (state.titleOptions.showTitleFlagFromMetadata === false) {
        return false;
    }

    return Boolean(state.titleOptions.title || state.isInDesignerMode);
};
